import Modal from '@ui/Modal/component'
import Slider from '@ui/Slider/component'
import { isDesktop, isMobile } from 'assets/core/js/common'
import ProductFavoriteButton from 'assets/core/js/module/product-favorite-button'

export interface Options {
  onClickResetBtn?: (el: HTMLElement, buttonEl: HTMLButtonElement) => void
  onClickProduct?: (el: HTMLElement) => void
}

const initSlider = (el: HTMLElement): void => {
  const sliderEl = el.querySelector<HTMLElement>('.slider')

  if (!sliderEl) {
    return
  }

  const totalSlides = sliderEl.querySelectorAll<HTMLElement>('.slide')

  if (totalSlides.length === 0) {
    return
  }

  Slider(sliderEl, {
    navigation: {
      prevEl: sliderEl?.parentElement?.querySelector<HTMLElement>('.slider-navigation .slider-button-prev'),
      nextEl: sliderEl?.parentElement?.querySelector<HTMLElement>('.slider-navigation .slider-button-next'),
    },
    pagination: {
      el: sliderEl?.parentElement?.querySelector<HTMLElement>('.slider-pagination') ?? null,
    },
    spaceBetween: 16,
    on: {
      resize: (slider) => {
        if (isDesktop()) {
          slider.update({
            slidesPerView: 5,
            slidesPerGroup: 5,
          })
        } else {
          slider.update({
            slidesPerView: 'auto',
            slidesPerGroup: 1,
          })
        }
      },
    },
  })
}

const initResetButton = (el: HTMLElement, fn?: Options['onClickResetBtn']): void => {
  const buttonEl = el.querySelector<HTMLButtonElement>('.reset')
  const sliderWrapperEl = el.querySelector<HTMLElement>('.slider-wrapper')

  if (!buttonEl || !fn || !sliderWrapperEl) {
    return
  }

  const modalEl = el.querySelector<HTMLElement>('#modal-products-last-seen-reset')

  if (!modalEl) {
    return
  }

  const modal = Modal(modalEl)

  const cancelModalButtonEl = modalEl.querySelector<HTMLButtonElement>('#products-last-seen-modal-button-cancel')
  const resetModalButtonEl = modalEl.querySelector<HTMLButtonElement>('#products-last-seen-modal-button-reset')

  cancelModalButtonEl?.addEventListener('click', () => {
    modal.close()
  })

  resetModalButtonEl?.addEventListener('click', () => {
    fn(el, buttonEl)
    sliderWrapperEl.textContent = ''
    modal.close()
  })

  buttonEl.addEventListener('click', (e) => {
    e.stopPropagation()
    modal.open()
  })
}

const initFavoriteButtons = (el: HTMLElement): void => {
  el.querySelectorAll<HTMLButtonElement>('button.favorite').forEach((buttonEl) => {
    ProductFavoriteButton(buttonEl)
  })
}

const initLinks = (el: HTMLElement, onClickProduct?: Options['onClickProduct']): void => {
  el.querySelectorAll<HTMLAnchorElement>('.product-slide > a').forEach((linkEl) => {
    const url = linkEl.getAttribute('href')

    linkEl.addEventListener('click', (e) => {
      const productSlideElement = linkEl.closest<HTMLElement>('.product-slide')
      if (productSlideElement) {
        onClickProduct?.(productSlideElement)
      }

      e.preventDefault()

      if (url) {
        if (!isMobile()) {
          window.open(url)
        } else {
          document.location.href = url
        }
      }
    })
  })
}

export default (el: HTMLElement, options: Options = {}): void => {
  if (!el) {
    return
  }

  initSlider(el)
  initResetButton(el, options.onClickResetBtn)
  initFavoriteButtons(el)
  initLinks(el, options.onClickProduct)
}
